import { Inject, Injectable } from '@angular/core';

import { WindowService } from '../../shared/services/window.service';
import { CRYPTO_API_AVAILABLE } from './crypto-api-available.injection-token';

export const MSG_CRYPTO_API_NOT_AVAILABLE = 'CryptoAPI Not Available';

@Injectable({
    providedIn: 'root'
})
export class WebCryptoService {

    constructor(
        @Inject(CRYPTO_API_AVAILABLE) private readonly cryptoApiAvailable: boolean,
        private readonly windowService: WindowService
    ) {
    }

    public get crypto() {
        if (!this.cryptoApiAvailable) {
            throw new Error(MSG_CRYPTO_API_NOT_AVAILABLE);
        }

        return this.windowService.nativeWindow.crypto;
    }

}
